import * as Dialog from "@radix-ui/react-dialog";
// import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export default function AppDialog({
  open,
  onOpenChange,
  message,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  message: string;
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[10090] bg-black/50 backdrop-blur-sm" />
        <Dialog.Content
          aria-describedby={undefined}
          className={cn(
            "fixed left-1/2 top-1/2 z-[10100] -translate-x-1/2 -translate-y-1/2",
            "w-full max-w-sm rounded-2xl bg-white p-6 shadow-lg",
            // 2.4.7 Focus Visible — AA: the outline was removed with nothing put in
            // its place. Radix moves focus to the dialog content on open, so without a
            // ring a keyboard user has no indication of where focus went.
            "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          )}
        >
          <div className="mb-4 flex items-center justify-between">
            {/* <Dialog.Title className="text-lg font-semibold">
                            Data Unavailable
                        </Dialog.Title> */}
            {/* <Dialog.Close asChild>
                            <button className="text-gray-500 hover:text-black">
                                <X className="w-5 h-5" />
                            </button>
                        </Dialog.Close> */}
          </div>

          <Dialog.Description className="text-sm font-semibold text-gray-600">
            {message}
          </Dialog.Description>

          <div className="mt-6 flex justify-end">
            <Dialog.Close asChild>
              <Button variant="outline">OK</Button>
            </Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
